import moment, { Moment } from "moment";
import { IAssignment } from "@miplatform/types";
import { addToDate, getDate, subtractFromDate } from "@miplatform/utils";
import { ASSIGNMENTS_ALL_OPTION } from "./AssignmentsCalendar.constants";

export const countAssignments = (
  assignments: IAssignment[],
  templateId: string
) => {
  if (templateId === ASSIGNMENTS_ALL_OPTION) {
    return assignments.length;
  }

  return assignments.filter(
    ({ assignmentTemplateId }) => assignmentTemplateId === templateId
  ).length;
};

export const calculateAssignmentsAutoPublishRemainingTime = (
  targetTime: Moment
): string => {
  const now = getDate();
  const diffInSeconds = targetTime.diff(now, "seconds");

  if (diffInSeconds <= 0) {
    return "00:00:00";
  }

  const duration = moment.duration(diffInSeconds, "seconds");
  const hours = String(Math.floor(duration.asHours())).padStart(2, "0");
  const minutes = String(duration.minutes()).padStart(2, "0");
  const seconds = String(duration.seconds()).padStart(2, "0");

  return `${hours}:${minutes}:${seconds}`;
};

export const sortAssignmentsByScheduledDate = (
  a: IAssignment,
  b: IAssignment
) =>
  new Date(b.order?.effectiveScheduledDate as string).getTime() -
  new Date(a.order?.effectiveScheduledDate as string).getTime();

export const sortAssignmentsByConfirmedDate = (
  a: IAssignment,
  b: IAssignment
) =>
  new Date(a.order?.confirmedScheduleDate as string).getTime() -
  new Date(b.order?.confirmedScheduleDate as string).getTime();

export const getAssignmentDate = (date?: Moment | Date) => {
  const tomorrow = addToDate(date, 1);

  if (tomorrow.day() === 0) {
    return addToDate(tomorrow, 1);
  }

  return tomorrow;
};

export const getAssignmentsPreviousDate = (date?: Moment | Date) => {
  const dayBefore = subtractFromDate(date, 1);

  if (dayBefore.day() === 0) {
    return subtractFromDate(dayBefore, 1);
  }

  return dayBefore;
};

export const getAssignmentsDefaultDates = () => {
  const assignmentDate = getAssignmentDate();

  return {
    assignment: assignmentDate,
    current: getAssignmentsPreviousDate(assignmentDate),
  };
};
